import { FC } from "react";
import { useParams } from "react-router-dom";
import halls from "../data/halls";

const HallDetailsPage: FC = () => {
    const { id } = useParams<{ id: string }>();
    let PARSED_ID: number = 0;
    if(id !== undefined){
        PARSED_ID = parseInt(id)
    }

    return (
        <section className="halldetails">
            <div className="halldetails__title">
                <h3>{halls[PARSED_ID].title}</h3>
            </div>
            <div className="halldetails__info">
                <div className="halldetails__info-address">
                    <p>Адреса: {halls[PARSED_ID].address}</p>
                    <a href={`tel:${halls[PARSED_ID].phone}`}>Телефон: {halls[PARSED_ID].phone}</a>
                    <iframe src={halls[PARSED_ID].map} loading="lazy" width="600" height="400"></iframe>
                </div>
                <div className="halldetails__info-image">
                    <img src={halls[PARSED_ID].image} alt="gym" />
                </div>
            </div>
        </section>
    );
};

export default HallDetailsPage;
